import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

export interface MarkConditionAddedToChartCriteria {
  questionnaireResponseId: string;
  conditionCode: string;
  conditionCodeSystem: string;
}

export const useMarkConditionAddedToChart = ({
  patientId,
  amazonVisitId,
}: {
  patientId?: string;
  amazonVisitId?: string;
} = {}) => {
  const queryClient = useQueryClient();

  return useApiMutation<void, MarkConditionAddedToChartCriteria>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.AmazonVisitIntake.MARK_CONDITION_ADDED_TO_CHART,
      mutationFn: async ({
        questionnaireResponseId,
        conditionCode,
        conditionCodeSystem,
      }: MarkConditionAddedToChartCriteria) => {
        await axiosInstance.put(
          `amazon-clinic/condition-extractions/${questionnaireResponseId}/condition-added-to-chart`,
          {
            condition_code: conditionCode,
            condition_code_system: conditionCodeSystem,
          },
        );
      },
      onSuccess: () => {
        if (patientId && amazonVisitId) {
          queryClient.invalidateQueries({
            queryKey: QueryKeys.Patient.Chart.AmazonVisitIntake.DEFAULT({
              patientId,
              amazonVisitId,
            }),
          });
        }
      },
    },
  });
};
